/* Puras Camisetas — next drop poll
   Public scoreboard. Falls back to per-device demo mode when unconfigured. */
(function () {
  'use strict';

  function init(root) {
    var endpoint = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
    var key = root.getAttribute('data-key') || '';
    var table = root.getAttribute('data-table') || 'artist_votes';
    var topN = parseInt(root.getAttribute('data-top'), 10) || 10;
    var allowAdd = root.getAttribute('data-allow-add') === '1';
    var live = !!(endpoint && key);

    var topEl = root.querySelector('[data-poll-top]');
    var restWrap = root.querySelector('[data-poll-rest]');
    var restEl = root.querySelector('[data-poll-restlist]');
    var restLabel = root.querySelector('[data-poll-more-label]');
    var emptyEl = root.querySelector('[data-poll-empty]');
    var statusEl = root.querySelector('[data-poll-status]');
    var form = root.querySelector('[data-poll-add]');
    var input = form ? form.querySelector('input') : null;

    var VOTED = 'pc_poll_voted';
    var DEMO = 'pc_poll_demo';

    function voted() {
      try { return JSON.parse(localStorage.getItem(VOTED) || '[]'); } catch (e) { return []; }
    }
    function markVoted(id) {
      var v = voted();
      if (v.indexOf(String(id)) === -1) { v.push(String(id)); }
      try { localStorage.setItem(VOTED, JSON.stringify(v)); } catch (e) {}
    }
    function hasVoted(id) { return voted().indexOf(String(id)) !== -1; }

    function demoRows() {
      try { return JSON.parse(localStorage.getItem(DEMO) || '[]'); } catch (e) { return []; }
    }
    function saveDemo(rows) {
      try { localStorage.setItem(DEMO, JSON.stringify(rows)); } catch (e) {}
    }

    function headers(extra) {
      var h = { apikey: key, Authorization: 'Bearer ' + key, 'Content-Type': 'application/json' };
      for (var k in extra) { h[k] = extra[k]; }
      return h;
    }

    function say(msg, bad) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.className = 'ck-poll__status' + (bad ? ' is-bad' : '');
    }

    function clean(name) {
      return name.replace(/\s+/g, ' ').trim().slice(0, 40);
    }

    function fetchRows() {
      if (!live) return Promise.resolve(demoRows());
      return fetch(endpoint + '/rest/v1/' + table + '?select=id,name,votes&order=votes.desc,name.asc&limit=300',
                   { headers: headers() })
        .then(function (r) { return r.ok ? r.json() : []; })
        .catch(function () { return []; });
    }

    function row(item, place) {
      var li = document.createElement('li');
      li.className = 'ck-board__row';
      li.innerHTML =
        '<span class="ck-board__place">' + place + '</span>' +
        '<span class="ck-board__name"></span>' +
        '<span class="ck-board__votes">' + (item.votes || 0) + '</span>' +
        '<button type="button" class="ck-board__vote"' +
          (hasVoted(item.id) ? ' disabled aria-label="Already voted"' : '') + '>' +
          (hasVoted(item.id) ? 'Voted' : 'Vote') +
        '</button>';
      li.querySelector('.ck-board__name').textContent = item.name;
      var btn = li.querySelector('.ck-board__vote');
      btn.addEventListener('click', function () { vote(item, btn); });
      return li;
    }

    function render(rows) {
      topEl.innerHTML = '';
      restEl.innerHTML = '';
      if (!rows.length) {
        emptyEl.hidden = false;
        restWrap.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      rows.slice(0, topN).forEach(function (item, i) { topEl.appendChild(row(item, i + 1)); });
      var rest = rows.slice(topN);
      if (rest.length) {
        rest.forEach(function (item, i) { restEl.appendChild(row(item, topN + i + 1)); });
        if (restLabel) restLabel.textContent = 'Everyone else (' + rest.length + ')';
        restWrap.hidden = false;
      } else {
        restWrap.hidden = true;
      }
    }

    function refresh() { return fetchRows().then(render); }

    function vote(item, btn) {
      if (hasVoted(item.id)) return;
      btn.disabled = true;
      btn.textContent = 'Voted';
      markVoted(item.id);

      if (!live) {
        var rows = demoRows();
        rows.forEach(function (r) { if (String(r.id) === String(item.id)) { r.votes = (r.votes || 0) + 1; } });
        rows.sort(function (a, b) { return b.votes - a.votes || a.name.localeCompare(b.name); });
        saveDemo(rows);
        render(rows);
        return;
      }

      fetch(endpoint + '/rest/v1/rpc/vote_for_artist', {
        method: 'POST', headers: headers(), body: JSON.stringify({ artist_id: item.id })
      }).then(refresh).catch(refresh);
    }

    function add(name) {
      name = clean(name);
      if (name.length < 2) { say('That name is too short.', true); return; }

      if (!live) {
        var rows = demoRows();
        var dupe = rows.filter(function (r) { return r.name.toLowerCase() === name.toLowerCase(); })[0];
        if (dupe) { say('Already on the board — vote for it instead.'); render(rows); return; }
        rows.push({ id: 'd' + Date.now(), name: name, votes: 1 });
        markVoted(rows[rows.length - 1].id);
        rows.sort(function (a, b) { return b.votes - a.votes || a.name.localeCompare(b.name); });
        saveDemo(rows);
        render(rows);
        say('Added. Nobody can remove it.');
        return;
      }

      fetch(endpoint + '/rest/v1/' + table, {
        method: 'POST',
        headers: headers({ Prefer: 'return=representation' }),
        body: JSON.stringify({ name: name, votes: 1 })
      }).then(function (r) {
        if (r.status === 409) { say('Already on the board — vote for it instead.'); return refresh(); }
        if (!r.ok) { say("Couldn't add that just now.", true); return refresh(); }
        return r.json().then(function (data) {
          if (data && data[0]) markVoted(data[0].id);
          say('Added. Nobody can remove it.');
          return refresh();
        });
      }).catch(function () { say("Couldn't add that just now.", true); });
    }

    if (form && allowAdd) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        add(input.value);
        input.value = '';
      });
    }

    refresh();
  }

  document.querySelectorAll('[data-poll]').forEach(init);
})();
